import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import classNames from "classnames";

const HollowButton: FC<Props> = ({
  className = "",
  text,
  element,
  onClick,
  preventDefault,
}) => {
  return (
    <div
      onClick={(e) => {
        onClick?.();
        if (preventDefault) {
          e.stopPropagation();
        }
      }}
      className={classNames(styles.button, className)}
    >
      <>{element ? element : text}</>
    </div>
  );
};

export default HollowButton;
